import React, { FC, useEffect } from 'react';
import { Box, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import { RouteComponentProps } from 'react-router-dom';
import { UserState } from 'Models/Users/@types';
import { useDispatch, useSelector } from 'react-redux';
import { TDispatch } from 'Typings/Global';
import { ReduxStore } from 'stores';
import { OUser } from 'Models/Users/Model';
import useAsyncTask from 'hooks/useAsyncTask';
import LayoutWithPageLoading from 'Components/layout/LayoutWithPageLoading';
import useToastMessage from 'hooks/useToastMessage';
import SolidSmallIconButton from 'Components/Buttons/SolidSmallIconButton';
import LockOpenRoundedIcon from '@material-ui/icons/LockOpenRounded';
import LockIcon from '@material-ui/icons/Lock';

type StoreSelection = Pick<UserState, 'user' | 'commentList'>;
export interface UsersListProps extends RouteComponentProps<{ id: string }> { }

const UserDetail: FC<UsersListProps> = ({ match }) => {
    const id = match.params['id'];
    const dispatch = useDispatch<TDispatch>();
    const classes = useStyles();
    const { user } = useSelector<ReduxStore, StoreSelection>(({ Users: { user } }) => ({ user }));
    const { commentList } = useSelector<ReduxStore, StoreSelection>(({ Users: { commentList } }) => ({ commentList }));
    const toggleBannedTask = useAsyncTask(async () => await dispatch(OUser.postActivity(OUser.Activities.TOGGLE_PUBLISH, {}, { id: id, publish: !user?.isBanned })));
    const loading = toggleBannedTask.status === "PROCESSING";
    const withToast = useToastMessage();
    const toggleBanned = () => { withToast(toggleBannedTask.run, { successToastMessage: user?.isBanned ? "UnBanned successfully" : "Banned successfully" }); }
    const getCommentListDataTask = useAsyncTask(async () => dispatch(OUser.getEntityByItem(id, 'comments')));
    const getDataTask = useAsyncTask(async () => dispatch(OUser.getItem(id)));
    useEffect(() => {
        getDataTask.run();
        // eslint-disable-next-line
    }, [id]);
    useEffect(() => {
        getCommentListDataTask.run();
        // eslint-disable-next-line
    }, [id]);
    return (
        <LayoutWithPageLoading loading={getDataTask.status === 'PROCESSING' && getCommentListDataTask.status === 'PROCESSING'} assertedItems={[user]}>
            <Grid container className={classes.gridContainerAlignment}>
                <Grid item xl={4} lg={4} md={6} sm={12} xs={12} >
                    <Paper style={{ position: 'relative' }}>
                        <img src={user?._profileImage?.url} alt={''} width={250} height={250} className={classes.profileImageContainer} />
                        <Box className={classes.textContainerAlignment} pl={2} pb={2}>
                            <Typography variant={'h6'}>{user?.firstName} {user?.lastName}</Typography>
                            <Typography variant={'subtitle1'}>{user?.designation}</Typography>
                            <Typography variant={'body1'}>{user?.email}</Typography>
                            <Box pt={2}>
                                <Typography className={classes.commentStyle}>{commentList?.length} comments</Typography>
                                <Box pt={1} pr={2} textAlign={'right'}>
                                <SolidSmallIconButton onClick={toggleBanned} color={user?.isBanned ? undefined : 'contrast'} disabled={loading} >
                                    {
                                        user?.isBanned ?
                                            <LockOpenRoundedIcon fontSize={'small'} />
                                            :
                                            <LockIcon color={'error'} fontSize={'small'} />
                                    }
                                </SolidSmallIconButton>
                                </Box>
                            </Box>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </LayoutWithPageLoading>
    )
}
const useStyles = makeStyles((theme) => ({
    profileImageContainer: {
        objectFit: 'cover',
        border: '3px solid #21618C',
        borderRadius: 90,
        borderBottomLeftRadius: 2,
        position: 'absolute',
        top: '-70px',
        left: '12px',
        background: 'grey'
    },
    gridContainerAlignment: {
        paddingTop: '10%',
        justifyContent: 'center'
    },
    textContainerAlignment: {
        paddingTop: 200
    },
    commentStyle: {
        textAlign: 'right',
        color: '#FF69B4'
    }
}));
export default UserDetail;